import './home.css';
import {v4 as uuid} from 'uuid';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { RootState } from '../../../state/store';
import { useSelector } from 'react-redux';
import HomePagePropsService from '../../../services/homePagePropsService';
import { IIndustryComponentProps } from '../../common/industry-we-serve/interfaces/IIndustryComponentProps';
import Industry from '../../common/industry-we-serve/industry-we-serve.component';
import { IStepComponentProps } from '../../common/step/interfaces/IStepComponentProps';
import Step from '../../common/step/step.component';
import { IReasonComponentProps } from '../../common/reason/interfaces/IReasonComponentProps';
import Reason from '../../common/reason/reason.component';

const HomeComponent = (): JSX.Element => {
	const navigate = useNavigate();
	const phrases = useSelector((state: RootState) => state.phrases.value);
	const industriesWeServeProps: Array<IIndustryComponentProps> = HomePagePropsService.getIndustriesWeServeProps(phrases);
	const stepsProps: Array<IStepComponentProps> = HomePagePropsService.getStepsProps(phrases);
	const reasonsProps: Array<IReasonComponentProps> = HomePagePropsService.getReasonsProps(phrases);

	useEffect(() => {
		document.title = phrases[32];
	}, [phrases]);

	return <>
		<section id="home__heading-container">
			<div>
				<h1>Sharp IT</h1>
				<h2>Transforming Ideas into Web Solutions</h2>
			</div>
			<div></div>
		</section>
		<div id="home__content-container">
			<section id="home__welcome">
				<h3>{phrases[39]}</h3>
				<p>{phrases[40]}</p>
			</section>
			<section id="home__industries-we-serve">
				<h3>{phrases[41]}</h3>
				<ul>
					{industriesWeServeProps.map((props: IIndustryComponentProps) => {
							return <Industry key={uuid()} liClasses={props.liClasses} divId={props.divId} divClasses={props.divClasses} icon={props.icon} description={props.description} />
						})}
				</ul>
			</section>
			<section id="home__our-process">
				<div><h3>{phrases[48]}</h3></div>
				<div className='home__our-process-steps-container'>
					{stepsProps.map((props: IStepComponentProps) => {
							return <Step key={uuid()} heading={props.heading} description={props.description} index={props.index} isLastStep={props.isLastStep} />
						})}
				</div>
			</section>
			<section id="home__why-choose-us">
				<h3>{phrases[67]}</h3>
				<ul>
					{reasonsProps.map((props: IReasonComponentProps, index: number) => {
							return <Reason key={uuid()} heading={props.heading} description={props.description} />
						})}
				</ul>
			</section>
			<section id="home__explore-services">
				<div className='corners-container'>
					<div className='content-container d-flex'>
						<h3>{phrases[68]}</h3>
						<button onClick={() => navigate("/services")}>{phrases[69]}</button>
					</div>
				</div>
			</section>
		</div>
	</>
}

export default HomeComponent
